import { IndicationYesNoOptions } from "../helpers/index";
export const tubeTypeOptions = [
  {
    value: "minifilter",
    label: "Minifilter",
  },
  {
    value: "standaardbuis",
    label: "Standaardbuis",
  },
  {
    value: "volledigFilter",
    label: "Volledig filter",
  },
  {
    value: "filterlozeBuis",
    label: "Filterloze buis",
    onlyImbroA: true,
  },
] as const;
export const tubeTypeOptionsType = tubeTypeOptions.map(({ value }) => value);
export type TubeTypeOptions = (typeof tubeTypeOptionsType)[number];

export const tubeStatusOptions = [
  {
    value: "gebruiksklaar",
    label: "Gebruiksklaar",
  },
  {
    value: "nietGebruiksklaar",
    label: "Niet gebruiksklaar",
  },
  {
    value: "onbruikbaar",
    label: "Onbruikbaar",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const tubeStatusOptionsType = tubeStatusOptions.map(({ value }) => value);
export type TubeStatusOptions = (typeof tubeStatusOptionsType)[number];

export const tubeTopPositioningMethodOptions = [
  {
    value: "afgeleidSbl",
    label: "Afgeleid sbl",
  },
  {
    value: "AHN2",
  },
  {
    value: "AHN3",
  },
  {
    value: "AHN4",
  },
  {
    value: "RTKGPS0tot4cm",
    label: "RTK GPS 0 tot 4cm",
  },
  {
    value: "RTKGPS4tot10cm",
    label: "RTK GPS 4 tot 10cm",
  },
  {
    value: "RTKGPS10tot20cm",
    label: "RTK GPS 10 tot 20cm",
  },
  {
    value: "RTKGPS20tot100cm",
    label: "RTK GPS 20 tot 100cm",
  },
  {
    value: "tachymetrie0tot10cm",
    label: "Tachymetrie 0 tot 10cm",
  },
  {
    value: "tachymetrie10tot50cm",
    label: "Tachymetrie 10 tot 50cm",
  },
  {
    value: "waterpassing0tot2cm",
    label: "Waterpassing 0 tot 2cm",
  },
  {
    value: "waterpassing2tot4cm",
    label: "Waterpassing 2 tot 4cm",
  },
  {
    value: "waterpassing4tot10cm",
    label: "Waterpassing 4 tot 10cm",
  },
  {
    value: "AHN1",
    onlyImbroA: true,
  },
  {
    value: "geen",
    label: "Geen",
    onlyImbroA: true,
  },
  {
    value: "GPSOnbekend",
    label: "GPS onbekend",
    onlyImbroA: true,
  },
  {
    value: "kaartOnbekend",
    label: "Kaart onbekend",
    onlyImbroA: true,
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const tubeTopPositioningMethodOptionsType = tubeTopPositioningMethodOptions.map(
  ({ value }) => value
);
export type TubeTopPositioningMethodOptions = (typeof tubeTopPositioningMethodOptionsType)[number];

export const tubePackingMaterialOptions = [
  {
    value: "bentoniet",
    label: "Bentoniet",
  },
  {
    value: "bentonietFiltergrind",
    label: "Bentoniet filtergrind",
  },
  {
    value: "boorgatmateriaal",
    label: "Boorgatmateriaal",
  },
  {
    value: "filtergrind",
    label: "Filtergrind",
  },
  {
    value: "grind",
    label: "Grind",
  },
  {
    value: "grout",
    label: "Grout",
  },
  {
    value: "volgensGerelateerdeVerkenning",
    label: "Volgens gerelateerde verkenning",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const tubePackingMaterialOptionsType = tubePackingMaterialOptions.map(({ value }) => value);
export type TubePackingMaterialOptions = (typeof tubePackingMaterialOptionsType)[number];

export const tubeMaterialOptions = [
  {
    value: "beton",
    label: "Beton",
  },
  {
    value: "gres",
    label: "Gres",
  },
  {
    value: "hout",
    label: "Hout",
  },
  {
    value: "ijzer",
    label: "IJzer",
  },
  {
    value: "koper",
    label: "Koper",
  },
  {
    value: "messing",
    label: "Messing",
  },
  {
    value: "pe",
    label: "PE",
  },
  {
    value: "peHighDensity",
    label: "Pe hoge densiteit",
  },
  {
    value: "peLowDensity",
    label: "Pe lage densiteit",
  },
  {
    value: "peHighDensityPvc",
    label: "Pe hoge densiteit pvc",
  },
  {
    value: "pePvc",
    label: "Pe pvc",
  },
  {
    value: "pvc",
    label: "PVC",
  },
  {
    value: "staal",
    label: "Staal",
  },
  {
    value: "staalGegalvaniseerd",
    label: "Staal gegalvaniseerd",
  },
  {
    value: "staalRoestvrij",
    label: "Staal roestvrij",
  },
  {
    value: "asbest",
    label: "Asbest",
    onlyImbroA: true,
  },
  {
    value: "teflon",
    label: "Teflon",
    onlyImbroA: true,
  },
  {
    value: "houtStaal",
    label: "Hout staal",
    onlyImbroA: true,
  },
  {
    value: "koperStaal",
    label: "Koper staal",
    onlyImbroA: true,
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
  {
    value: "pvcStaal",
    label: "Pvc staal",
    onlyImbroA: true,
  },
] as const;
export const tubeMaterialOptionsType = tubeMaterialOptions.map(({ value }) => value);
export type TubeMaterialOptions = (typeof tubeMaterialOptionsType)[number];

export const glueOptions = [
  {
    value: "geen",
    label: "Geen",
  },
  {
    value: "ongespecificeerd",
    label: "Ongespecificeerd",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const glueOptionsType = glueOptions.map(({ value }) => value);
export type GlueOptions = (typeof glueOptionsType)[number];

export const sockMaterialOptions = [
  {
    value: "geen",
    label: "Geen",
  },
  {
    value: "kopergaas",
    label: "Kopergaas",
  },
  {
    value: "nylon",
    label: "Nylon",
  },
  {
    value: "pp",
    label: "PP",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const sockMaterialOptionsType = sockMaterialOptions.map(({ value }) => value);
export type SockMaterialOptions = (typeof sockMaterialOptionsType)[number];

export const screenProtectionOptions = [
  {
    value: "dubbelwandigFilterMetFilterkous",
    label: "Dubbelwandig filter met filterkous",
  },
  {
    value: "dubbelwandigFilterZonderFilterkous",
    label: "Dubbelwandig filter zonder filterkous",
  },
  {
    value: "filterkousZonderOpvulling",
    label: "Filterkous zonder opvulling",
  },
  {
    value: "filterkousMetOpvulling",
    label: "Filterkous met opvulling",
  },
  {
    value: "geen",
    label: "Geen",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const screenProtectionOptionsType = screenProtectionOptions.map(({ value }) => value);
export type ScreenProtectionOptions = (typeof screenProtectionOptionsType)[number];

export const electrodePackingMaterialOptions = [
  {
    value: "filtergrind",
    label: "Filtergrind",
  },
  {
    value: "klei",
    label: "Klei",
  },
  {
    value: "volgensGerelateerdeVerkenning",
    label: "Volgens gerelateerde verkenning",
  },
  {
    value: "zand",
    label: "Zand",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const electrodePackingMaterialOptionsType = electrodePackingMaterialOptions.map(
  ({ value }) => value
);
export type ElectrodePackingMaterialOptions = (typeof electrodePackingMaterialOptionsType)[number];

export const electrodeStatusOptions = [
  {
    value: "gebruiksklaar",
    label: "Gebruiksklaar",
  },
  {
    value: "Niet gebruiksklaar",
    label: "Niet gebruiksklaar",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const electrodeStatusOptionsType = electrodeStatusOptions.map(({ value }) => value);
export type ElectrodeStatusOptions = (typeof electrodeStatusOptionsType)[number];

export type Electrode = {
  electrodeNumber: string;
  electrodePackingMaterial: ElectrodePackingMaterialOptions;
  electrodeStatus: ElectrodeStatusOptions;
  electrodePosition: number; // between -750  and 50
};

export type GeoOhmCable = {
  cableNumber: string;
  electrodes: Electrode[];
};

export type MonitoringTube = {
  tubeNumber: string;
  tubeType: TubeTypeOptions;
  artesianWellCapPresent: IndicationYesNoOptions;
  sedimentSumpPresent: IndicationYesNoOptions;
  numberOfGeoOhmCables: number; // between 0 and 10
  tubeTopDiameter: number; // between 3 and 1000
  variableDiameter: IndicationYesNoOptions;
  tubeStatus: TubeStatusOptions;
  tubeTopPosition: number; // between -10 and 325
  tubeTopPositioningMethod: TubeTopPositioningMethodOptions;
  tubePackingMaterial: TubePackingMaterialOptions;
  tubeMaterial: TubeMaterialOptions;
  glue: GlueOptions;
  screenLength: number; // between 0.02 and 100
  screenProtection: ScreenProtectionOptions;
  sockMaterial: SockMaterialOptions;
  plainTubePartLength: number;
  sedimentSumpLength: number; // Atleast 0.05
  geoOhmCables: GeoOhmCable[];
};
